export const isDevelopment = () => {
  return (window.location.href.indexOf('order-web.dev') > 0 || window.location.href.indexOf('localhost') > 0)
}